import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const key = 'jobActions';

const rootSelector = (state) => {
  if (state && state[key]) {
    return state[key];
  }
  return initialState;
};

export const jobActionsErrorSelector = (action) => createSelector(rootSelector, ({ error }) => !!error[action]);
export const jobActionsDialogStateSelector = (dialog) =>
  createSelector(rootSelector, ({ dialogs }) => !!dialogs[dialog]);
export const jobDownloadMessageSelector = createSelector(
  rootSelector,
  ({ message }) => message.jobApplicationDownload.description,
);
